module.exports = __webpack_public_path__ + "media/images/common/header_bg-fee2b27fd77655945ff090acc11cb6c0.jpg";